import { ApiBaseService } from '@/services/ApiBase.service'

export class DownloadsService extends ApiBaseService<number[]> {
  readonly apiController = 'downloads'
}
